import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PortaitPreview, fontSizeValue } from '@modules/report-generator/constants';
import { LibraryPage, ReportConfig } from '@modules/report-generator/interfaces';
import { ReportElement } from '@modules/report-generator/interfaces/elements';
import { createState } from '@shared/helpers/create-state.helper';

@Component({
  selector: 'app-report-page',
  templateUrl: './report-page.component.html',
  styleUrls: ['./report-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportPageComponent implements OnChanges {
  @Input() page!: LibraryPage;
  @Input() pageNumber: number;
  @Input() reportConfig!: ReportConfig;
  @Input() scale = 1;

  performanceDevelopmentCharts = createState<Array<any>>([]);

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reportConfig']) {
      const metabolicData = this.reportConfig?.metabolicProfile?.[4].plots;
      if (metabolicData) {
        this.performanceDevelopmentCharts.set(metabolicData);
      }
    }
  }

  getElementStyle(element: ReportElement): Record<string, any> {
    const actualPageDimensions = this.getActualPageDimensions();
    const baseSize = this.page.orientation === 'landscape' ? actualPageDimensions.height : actualPageDimensions.width;

    return {
      position: 'absolute',
      fontSize: `${fontSizeValue * this.scale}px`,
      left: `${(element.left / 100) * baseSize}px`,
      top: `${(element.top / 100) * baseSize}px`,
      width: `${(element.width / 100) * baseSize}px`,
      height: `${(element.height / 100) * baseSize}px`,
      overflow: 'hidden',
      zIndex: element.zIndex ?? 0,
    };
  }

  getDisplayDimensions(): { width: string; height: string; transform: string; transformOrigin: string } {
    const actualPageDimensions = this.getActualPageDimensions();

    return {
      width: `${actualPageDimensions.width}px`,
      height: `${actualPageDimensions.height}px`,
      transform: `scale(${this.scale})`,
      transformOrigin: 'top left',
    };
  }

  getWrapperDimensions(): { width: string; height: string } {
    const actualPageDimensions = this.getActualPageDimensions();

    return {
      width: `${actualPageDimensions.width * this.scale}px`,
      height: `${actualPageDimensions.height * this.scale}px`,
    };
  }

  private getActualPageDimensions(): { width: number; height: number } {
    const base = { width: PortaitPreview.width * this.scale, height: PortaitPreview.height * this.scale };
    return this.page.orientation === 'landscape' ? { width: base.height, height: base.width } : base;
  }
}
